import { ChevronLeft } from "@mui/icons-material";
import { Grid, Collapse } from "@mui/material";
import React from "react";
import { Suggestion } from "./Suggestion";

interface SuggestionsListProps {
    title: string;
    children: React.ReactNode;
}

export function SuggestionsList({ title, children }: SuggestionsListProps) {
    const [isExpanded, setIsExpanded] = React.useState(false);

    return (
        <Grid container direction="column" flexWrap="nowrap" rowGap={1}>
            <Suggestion onClick={() => setIsExpanded((expanded) => !expanded)}>
                {title}{" "}
                <ChevronLeft
                    fontSize="small"
                    sx={{
                        ml: 1,
                        transition: "rotate 0.3s ease-in-out",
                        rotate: isExpanded ? "-90deg" : "0deg",
                    }}
                />
            </Suggestion>
            <Collapse in={isExpanded} unmountOnExit>
                <Grid
                    container
                    item
                    direction="row"
                    rowGap={1 / 2}
                    columnGap={1 / 2}
                    pl={2}
                >
                    {children}
                </Grid>
            </Collapse>
        </Grid>
    );
}

SuggestionsList.displayName = "SuggestionsList";
SuggestionsList.ListItem = Suggestion;
